import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from "react-redux";

//Tables
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../utils/MyTable';

import { Checkbox, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import WarningIcon from '@material-ui/icons/Warning';

import moment from 'moment';

import allActions from '../../actions';
import { ClientDataImportAPI } from '../../API/client_data_import';
import { myLabelInput, tabs, unoTheme } from '../../assets/styles/unoTheme';
import MyContentLoadModal from '../utils/MyContentLoadModal';
import MySelect from '../utils/MySelect';
import { MyTab, MyTabs } from '../utils/MyTabs';
import UnoButton from '../utils/UnoButton';
import { applyMaskAccount, applyMaskAmount } from '../utils/utils';
import { getRegimeOptions, isRegimeEnabled } from '../utils/accountRegimes';

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: theme.spacing(2),
    },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between'
        }
    },

    tableTh: {
        fontWeight: 'bold'
    },
    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },
    gray: {
        color: unoTheme.defaultTextColor,
    },
    warningColor: {
        color: unoTheme.warningColor
    },
    label: myLabelInput,

    noPaddingRight: {
        paddingRight: '0px !important',
    },

    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },

    ellipsis: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    arrowTableIcon: {
        padding: '0px',
        '& .MuiSvgIcon-root': {
            color: unoTheme.mainColor,
        }
    },

    newBadge: {
        color: "white",
        fontSize: "11px",
        padding: "2px 6px",
        fontWeight: "bold",
        background: unoTheme.mainColor,
        borderRadius: "15px",
        whiteSpace: 'nowrap',
    },

    statusCell: {
        background: unoTheme.auxYellowTable,
    },

    counters: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: '12px',
    },

    detailContent: {
        padding: theme.spacing(2),
        background: unoTheme.secondaryTuplaTable,
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },

    detailWarning: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '12px',
    },

    detailLine: {
        fontSize: '12px',
        color: unoTheme.defaultTextColor,
    },

    validateMessage: {
        color: unoTheme.redMoney,
        textAlign: 'center',
        padding: '16px',
        backgroundColor: '#eeeeee',
        borderRadius: '5px',
    },

    sectionLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginTop: theme.spacing(1),
    },

}));

const WARNING_LABELS = {
    CLOSED_MONTHS: 'Há registros em meses já fechados na carteira de destino — serão ignorados',
    BEFORE_TARGET_PORTFOLIO_INIT: 'Há registros anteriores ao início da carteira de destino',
    REGIME_NOT_SEGREGATED: 'A conta de origem possui segregação, mas o destino não é segregado — confira o regime na aba Contas',
    OPENING_BALANCE_AFTER_TARGET_INIT: 'O ativo começa depois do início da carteira de destino com saldo de abertura diferente de zero — '
        + 'esse saldo precisará virar movimentação, senão o lançamento do mês será barrado',
};

/**
 * Rótulo curto das contagens de saldos/movimentações de um ativo.
 */
function CountersCell({ counters, classes }) {

    if (!counters) return <span>{'-'}</span>;

    return (
        <div className={classes.counters}>
            <span className={counters.toInsert > 0 ? classes.green : classes.gray}>
                {counters.toInsert}
            </span>
            {
                counters.alreadyInTarget > 0 ?
                    <span className={classes.gray}>{'(' + counters.alreadyInTarget + ' já existem)'}</span>
                    : null
            }
            {
                counters.blockedByClosedMonth > 0 ?
                    <span className={classes.warningColor}>{'(' + counters.blockedByClosedMonth + ' em mês fechado)'}</span>
                    : null
            }
        </div>
    );
}

/**
 * Linha de ativo (fundo ou título) com detalhe expansível.
 */
function AssetImportRow({ row, index, isTitle, classes, onCheck }) {

    const [open, setOpen] = useState(false);

    const mainLabel = isTitle
        ? [row.labelTitleType, row.titleName].filter(el => el).join(' - ')
        : row.fundName;

    const secondaryLabel = isTitle
        ? [
            row.dueDate ? 'Venc: ' + moment.utc(row.dueDate).format('DD/MM/YYYY') : null,
            row.tradingNote ? 'N.N: ' + row.tradingNote : null,
            row.marking,
        ].filter(el => el).join(' | ')
        : row.cnpj;

    return (
        <>
            <TableRow>

                <TableCell align="center" className='noPaddingCell'>
                    <Checkbox
                        checked={row.toImport === true}
                        color="primary"
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => onCheck(e.target.checked, index)}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                </TableCell>

                <TableCell align="center" className={classes.statusCell}>
                    {
                        row.status === 'MATCHED' ?
                            <CheckCircleIcon className={classes.green} />
                            : <span className={classes.newBadge}>{'NOVO!'}</span>
                    }
                </TableCell>

                <TableCell align="left">
                    <Typography className={classes.ellipsis} style={{ fontSize: '12px', fontWeight: 'bold' }}>
                        {mainLabel}
                    </Typography>
                    <Typography className={classes.ellipsis} style={{ fontSize: '11px', color: unoTheme.defaultTextColor }}>
                        {secondaryLabel}
                    </Typography>
                </TableCell>

                <TableCell align="center">{row.numberAccount ? applyMaskAccount(row.numberAccount) : '-'}</TableCell>
                <TableCell align="center">{row.agency ? row.agency : '-'}</TableCell>
                <TableCell align="center" className={classes.blue}>
                    {row.balances && row.balances.firstPeriod ? row.balances.firstPeriod : '-'}
                </TableCell>

                <TableCell align="center">
                    <CountersCell counters={row.balances} classes={classes} />
                </TableCell>
                <TableCell align="center">
                    <CountersCell counters={row.transactions} classes={classes} />
                </TableCell>

                <TableCell align="center" className='noPaddingCell'>
                    <IconButton
                        className={classes.arrowTableIcon}
                        size="small"
                        onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>

            </TableRow>

            <TableRow>
                <TableCell colSpan={9} style={{ padding: 0 }}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <div className={classes.detailContent}>

                            <Typography className={classes.detailLine}>
                                {'Conta: ' + (row.instituitionName || '-')
                                    + ' | Segregação: ' + (row.regimeName || '-')}
                            </Typography>

                            <Typography className={classes.detailLine}>
                                {'Saldos na origem: ' + (row.balances ? row.balances.total : 0)
                                    + (row.balances && row.balances.firstPeriod
                                        ? ' (' + row.balances.firstPeriod + ' a ' + row.balances.lastPeriod + ')'
                                        : '')}
                            </Typography>

                            <Typography className={classes.detailLine}>
                                {'Movimentações na origem: ' + (row.transactions ? row.transactions.total : 0)}
                            </Typography>

                            {
                                isTitle ?
                                    <Typography className={classes.detailLine}>
                                        {'Quantidade: ' + applyMaskAmount(row.quantityPurchased || 0)
                                            + ' | Preço unitário: ' + applyMaskAmount(row.priceTitle || 0, true)
                                            + (row.purchaseDate ? ' | Aplicação: ' + moment.utc(row.purchaseDate).format('DD/MM/YYYY') : '')}
                                    </Typography>
                                    :
                                    <Typography className={classes.detailLine}>
                                        {'Saldo inicial na origem: ' + applyMaskAmount(row.balance || 0, true)}
                                    </Typography>
                            }

                            {
                                row.warnings && row.warnings.map((warning, wIndex) => (
                                    <div className={classes.detailWarning} key={'warning-' + index + '-' + wIndex}>
                                        <WarningIcon className={classes.warningColor} />
                                        <span>{WARNING_LABELS[warning] || warning}</span>
                                    </div>
                                ))
                            }

                        </div>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

/**
 * Passo 2 do fluxo de importação de lançamentos entre clientes: tela de matches.
 *
 * O backend devolve o plano (o que casa por CNPJ do fundo + conta, o que precisa ser criado
 * e quantos saldos/movimentações viriam de cada ativo) e o usuário marca linha por linha o
 * que quer trazer. A execução é uma única chamada transacional.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {object} props.sourceClient cliente de origem escolhido no passo 1
 * @param {function} props.handleModalImport (open, update)
 */
export default function ImportFromClientModal({ open, sourceClient, handleModalImport }) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn);

    const [loader, setLoader] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [previewData, setPreviewData] = useState(undefined);
    const [fundAssets, setFundAssets] = useState([]);
    const [titleAssets, setTitleAssets] = useState([]);
    const [regimesNewAccountsStructure, setRegimesNewAccountsStructure] = useState({});

    const [tabValue, setTabValue] = useState(0);

    //Mesma lista (e mesma habilitação por flag do cliente) usada no import por PDF
    const regimeOptions = useMemo(() => getRegimeOptions(clientOn), [clientOn])

    const doPreview = useCallback(async () => {

        setErrorMessage('');
        setPreviewData(undefined);
        setFundAssets([]);
        setTitleAssets([]);
        setRegimesNewAccountsStructure({});
        setTabValue(0);
        setLoader('Analisando informações do cliente de origem...');

        const response = await ClientDataImportAPI.preview(sourceClient.id, clientOn.client.id);

        if (!response.success) {
            setErrorMessage(response.body && response.body.message
                ? response.body.message
                : 'Falha ao analisar as informações do cliente de origem');
            setLoader('');
            return;
        }

        const data = response.body;

        //Por default marca-se tudo que ainda geraria alguma inserção
        const hasSomethingToInsert = (el) => el.status === 'TO_CREATE'
            || el.balances.toInsert > 0
            || el.transactions.toInsert > 0;

        setPreviewData(data);
        setFundAssets(data.fundAssets.map(el => ({ ...el, toImport: hasSomethingToInsert(el) })));
        setTitleAssets(data.titleAssets.map(el => ({ ...el, toImport: hasSomethingToInsert(el) })));

        //Regime pré-selecionado com o da origem; fica em branco quando a opção não existe no
        //destino (conta financeira em cliente não segregado), obrigando a escolha
        const regimes = {};
        data.accounts.filter(el => el.status === 'TO_CREATE').forEach(acc => {
            const available = isRegimeEnabled(clientOn, acc.accountRegimeId);
            regimes[acc.sourceAccountId] = available ? acc.accountRegimeId : '';
        });
        setRegimesNewAccountsStructure(regimes);

        setLoader('');

    }, [sourceClient, clientOn])

    useEffect(() => {

        if (!open || !sourceClient || !clientOn || !clientOn.client) return;
        doPreview();

    }, [open, sourceClient])

    const handleCheckFundAsset = (checked, index) => {
        const newList = [...fundAssets];
        newList[index].toImport = checked;
        setFundAssets(newList);
    }

    const handleCheckTitleAsset = (checked, index) => {
        const newList = [...titleAssets];
        newList[index].toImport = checked;
        setTitleAssets(newList);
    }

    const handleCheckAllFundAssets = (checked) => {
        setFundAssets(fundAssets.map(el => ({ ...el, toImport: checked })));
    }

    const handleCheckAllTitleAssets = (checked) => {
        setTitleAssets(titleAssets.map(el => ({ ...el, toImport: checked })));
    }

    const handleRegimeChange = (sourceAccountId, value) => {
        setRegimesNewAccountsStructure({
            ...regimesNewAccountsStructure,
            [sourceAccountId]: value,
        });
    }

    const selectedFundAssets = useMemo(() => fundAssets.filter(el => el.toImport), [fundAssets]);
    const selectedTitleAssets = useMemo(() => titleAssets.filter(el => el.toImport), [titleAssets]);

    //Contas envolvidas na seleção — a conta é criada quando algum ativo dela está marcado
    const involvedAccounts = useMemo(() => {

        if (!previewData) return [];

        const neededIds = new Set([
            ...selectedFundAssets.map(el => el.sourceAccountId),
            ...selectedTitleAssets.map(el => el.sourceAccountId),
        ]);

        return previewData.accounts.filter(el => neededIds.has(el.sourceAccountId));

    }, [previewData, selectedFundAssets, selectedTitleAssets])

    const accountsToCreate = useMemo(() => involvedAccounts.filter(el => el.status === 'TO_CREATE'),
        [involvedAccounts]);

    const totals = useMemo(() => {

        const selected = [...selectedFundAssets, ...selectedTitleAssets];

        return {
            structuresToCreate: accountsToCreate.length + selected.filter(el => el.status === 'TO_CREATE').length,
            balancesToInsert: selected.reduce((sum, el) => sum + el.balances.toInsert, 0)
                + involvedAccounts.reduce((sum, el) => sum + el.balances.toInsert, 0),
            transactionsToInsert: selected.reduce((sum, el) => sum + el.transactions.toInsert, 0),
        };

    }, [selectedFundAssets, selectedTitleAssets, involvedAccounts, accountsToCreate])

    /**
     * Códigos que travam o botão de importação, no mesmo esquema do DataImportFromPdfModal.
     */
    const checkOkToImport = useCallback(() => {

        const errors = [];

        if (!previewData) return ['NO_PREVIEW'];

        if (!selectedFundAssets.length && !selectedTitleAssets.length) errors.push('NO_SELECTION');

        if (accountsToCreate.some(acc => !regimesNewAccountsStructure[acc.sourceAccountId])) {
            errors.push('MISSING_REGIME');
        }

        if (totals.structuresToCreate === 0
            && totals.balancesToInsert === 0
            && totals.transactionsToInsert === 0
            && (selectedFundAssets.length || selectedTitleAssets.length)) {
            errors.push('NOTHING_TO_INSERT');
        }

        return errors;

    }, [previewData, selectedFundAssets, selectedTitleAssets, accountsToCreate, regimesNewAccountsStructure, totals])

    async function doImport() {

        setLoader('Importando informações...');

        const response = await ClientDataImportAPI.execute({
            sourceClientId: sourceClient.id,
            targetClientId: clientOn.client.id,
            selectedFundAssetIds: selectedFundAssets.map(el => el.sourceAssetId),
            selectedTitleAssetIds: selectedTitleAssets.map(el => el.sourceTitleAssetId),
            accountRegimeMap: regimesNewAccountsStructure,
        });

        setLoader('');

        if (!response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: response.body && response.body.message
                    ? response.body.message
                    : 'Falha ao importar as informações',
            }))

            return;
        }

        const { report } = response.body;

        const aprCreated = (report.aprDescriptionsCreated || 0) + (report.clientAprDataCreated || 0);

        dispatch(allActions.mainAlertActions.setMainAlert({
            show: true,
            type: 'success',
            message: 'Importação concluída: '
                + report.accountsCreated + ' conta(s), '
                + report.fundAssetsCreated + ' ativo(s) de fundo, '
                + report.titleAssetsCreated + ' título(s), '
                + (report.accountBalancesInserted + report.assetBalancesInserted + report.titleBalancesInserted) + ' saldo(s) e '
                + report.transactionsInserted + ' movimentação(ões)'
                + (aprCreated > 0
                    ? '. APR: ' + report.aprDescriptionsCreated + ' descrição(ões) e '
                    + report.clientAprDataCreated + ' vigência(s) criadas no destino.'
                    : ''),
        }))

        handleModalImport(false, true);
    }

    const errors = checkOkToImport();

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            PaperProps={{
                style: {
                    height: '90vh',
                },
            }}
            onClose={() => handleModalImport(false)}>

            <DialogTitle className={classes.dialogTitle}>
                <span>{'Importar lançamentos de outro cliente'}</span>
                {
                    sourceClient && clientOn && clientOn.client ?
                        <span style={{ fontSize: '14px', color: unoTheme.defaultTextColor }}>
                            {sourceClient.label_name}
                            {' → '}
                            <span style={{ color: unoTheme.mainColor, fontWeight: 'bold' }}>
                                {clientOn.client.label_name}
                            </span>
                        </span>
                        : null
                }
            </DialogTitle>

            <DialogContent className={classes.contentModal}>

                {
                    loader ?
                        <MyContentLoadModal show={true} message={loader} />
                        : null
                }

                {
                    !loader && errorMessage ?
                        <Typography variant="body2" className={classes.validateMessage}>
                            {errorMessage}
                        </Typography>
                        : null
                }

                {
                    !loader && !errorMessage && previewData ?
                        <>
                            <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: "auto" }}>

                                <MyTabs
                                    value={tabValue}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    onChange={(event, newValue) => setTabValue(newValue)}>

                                    <MyTab label={`Fundos [${fundAssets.length}]`} />
                                    <MyTab label={`Títulos [${titleAssets.length}]`} />
                                    <MyTab label={`Contas [${involvedAccounts.length}]`} />

                                </MyTabs>

                            </div>

                            <div style={{ height: "calc(100% - 72px)" }}>

                                {
                                    tabValue === 0 &&
                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">

                                        <colgroup>
                                            <col width="5%" />
                                            <col width="8%" />
                                            <col width="34%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" className='noPaddingCell'>
                                                    <Checkbox
                                                        checked={fundAssets.length > 0 && selectedFundAssets.length === fundAssets.length}
                                                        indeterminate={selectedFundAssets.length > 0 && selectedFundAssets.length < fundAssets.length}
                                                        color="primary"
                                                        onChange={(e) => handleCheckAllFundAssets(e.target.checked)}
                                                    />
                                                </TableCell>
                                                <TableCell className={classes.tableTh} align="center">Status</TableCell>
                                                <TableCell className={classes.tableTh} align="left">Fundo</TableCell>
                                                <TableCell className={classes.tableTh} align="center">CC</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Ag.</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Início</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Saldos</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Movim.</TableCell>
                                                <TableCell className={classes.tableTh} align="center"></TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {
                                                fundAssets.map((row, index) => (
                                                    <AssetImportRow
                                                        key={'fund-asset-row-' + row.sourceAssetId}
                                                        row={row}
                                                        index={index}
                                                        isTitle={false}
                                                        classes={classes}
                                                        onCheck={handleCheckFundAsset} />
                                                ))
                                            }
                                        </TableBody>

                                    </MyTable>
                                }

                                {
                                    tabValue === 1 &&
                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">

                                        <colgroup>
                                            <col width="5%" />
                                            <col width="8%" />
                                            <col width="34%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" className='noPaddingCell'>
                                                    <Checkbox
                                                        checked={titleAssets.length > 0 && selectedTitleAssets.length === titleAssets.length}
                                                        indeterminate={selectedTitleAssets.length > 0 && selectedTitleAssets.length < titleAssets.length}
                                                        color="primary"
                                                        onChange={(e) => handleCheckAllTitleAssets(e.target.checked)}
                                                    />
                                                </TableCell>
                                                <TableCell className={classes.tableTh} align="center">Status</TableCell>
                                                <TableCell className={classes.tableTh} align="left">Título</TableCell>
                                                <TableCell className={classes.tableTh} align="center">CC</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Ag.</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Início</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Saldos</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Movim.</TableCell>
                                                <TableCell className={classes.tableTh} align="center"></TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {
                                                titleAssets.map((row, index) => (
                                                    <AssetImportRow
                                                        key={'title-asset-row-' + row.sourceTitleAssetId}
                                                        row={row}
                                                        index={index}
                                                        isTitle={true}
                                                        classes={classes}
                                                        onCheck={handleCheckTitleAsset} />
                                                ))
                                            }
                                        </TableBody>

                                    </MyTable>
                                }

                                {
                                    tabValue === 2 &&
                                    <MyTable
                                        style={{ marginTop: '8px' }}
                                        stickyHeader
                                        sizeheaders="verySmall"
                                        size="small">

                                        <colgroup>
                                            <col width="8%" />
                                            <col width="32%" />
                                        </colgroup>

                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.tableTh} align="center">Status</TableCell>
                                                <TableCell className={classes.tableTh} align="left">Instituição</TableCell>
                                                <TableCell className={classes.tableTh} align="center">CC</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Ag.</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Início</TableCell>
                                                <TableCell className={classes.tableTh} align="center">Saldos</TableCell>
                                                <TableCell className={classes.tableTh} align="right">Segregação</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {
                                                involvedAccounts.map((row) => (
                                                    <TableRow key={'account-row-' + row.sourceAccountId}>

                                                        <TableCell align="center" className={classes.statusCell}>
                                                            {
                                                                row.status === 'MATCHED' ?
                                                                    <CheckCircleIcon className={classes.green} />
                                                                    : <span className={classes.newBadge}>{'NOVO!'}</span>
                                                            }
                                                        </TableCell>

                                                        <TableCell align="left" className={classes.ellipsis}>
                                                            {row.instituitionName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.numberAccount ? applyMaskAccount(row.numberAccount) : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">{row.agency ? row.agency : '-'}</TableCell>
                                                        <TableCell align="center" className={classes.blue}>
                                                            {row.accountInit ? moment.utc(row.accountInit).format('MM/YYYY') : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <CountersCell counters={row.balances} classes={classes} />
                                                        </TableCell>

                                                        <TableCell className={classes.noPaddingRight} align="right">
                                                            {
                                                                row.status === 'TO_CREATE' ?
                                                                    <MySelect
                                                                        verysmall
                                                                        initblank
                                                                        value={regimesNewAccountsStructure[row.sourceAccountId] ?? ''}
                                                                        onChange={(e) => handleRegimeChange(row.sourceAccountId, e.target.value)}
                                                                        options={regimeOptions.map((option, optionIndex) => (
                                                                            <option key={'regime-import-client-' + row.sourceAccountId + '-' + optionIndex}
                                                                                value={option.value}>
                                                                                {option.name}
                                                                            </option>
                                                                        ))}
                                                                    />
                                                                    :
                                                                    <Typography style={{ fontSize: '12px' }}>
                                                                        {row.regimeName || '-'}
                                                                    </Typography>
                                                            }
                                                        </TableCell>

                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>

                                    </MyTable>
                                }

                            </div>

                            {
                                errors.includes('MISSING_REGIME') ?
                                    <Typography variant="body2" className={classes.validateMessage}>
                                        {'Defina a segregação das contas que serão criadas na aba Contas'}
                                    </Typography>
                                    : null
                            }

                            {
                                errors.includes('NOTHING_TO_INSERT') ?
                                    <Typography variant="body2" className={classes.validateMessage}>
                                        {'Todas as informações dos ativos selecionados já foram importadas'}
                                    </Typography>
                                    : null
                            }

                        </>
                        : null
                }

            </DialogContent>

            {
                !loader ?
                    <DialogActions className={classes.actionsFlex}>

                        <UnoButton onClick={() => handleModalImport(false)} color="secondary">
                            {'Cancelar'}
                        </UnoButton>

                        {
                            previewData && !errorMessage ?
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography style={{ fontSize: '12px', color: unoTheme.defaultTextColor }}>
                                            {totals.structuresToCreate + ' estrutura(s) a criar | '
                                                + totals.balancesToInsert + ' saldo(s) | '
                                                + totals.transactionsToInsert + ' movimentação(ões)'}
                                        </Typography>
                                        {
                                            previewData.aprSummary && previewData.aprSummary.transactionsWithApr > 0 ?
                                                <Typography style={{ fontSize: '11px', color: unoTheme.defaultTextColor }}>
                                                    {'APR: ' + previewData.aprSummary.transactionsWithApr
                                                        + ' movimentação(ões) da origem com APR | '
                                                        + previewData.aprSummary.descriptionsToCreate + ' descrição(ões) e '
                                                        + previewData.aprSummary.signatoriesToCreate
                                                        + ' vigência(s) a criar no destino'}
                                                </Typography>
                                                : null
                                        }
                                    </div>

                                    <UnoButton
                                        disabled={errors.length > 0}
                                        onClick={() => doImport()}
                                        type="success">
                                        {'Importar'}
                                    </UnoButton>
                                </div>
                                : null
                        }

                    </DialogActions>
                    : null
            }

        </Dialog>
    );
}
